{
  "newTitle": "Nouveau module",
  "editTitle": "Modifier le module",
  "saveLabel": "Enregistrer le module",
  "savingLabel": "Enregistrement",
  "titleLabel": "Titre",
  "titlePlaceholder": "Titre du module",
  "descriptionLabel": "Description",
  "descriptionPlaceholder": "Ce que couvre ce module",
  "thumbnailLabel": "Miniature",
  "keepCurrentImage": "Conserver l'image actuelle",
  "clearImage": "Effacer",
  "campusLabel": "Campus",
  "campusPlaceholder": "Choisir un campus",
  "categoryLabel": "Catégorie",
  "categoryPlaceholder": "Choisir une catégorie",
  "uploadTargetFailed": "Impossible de préparer le téléversement de la miniature.",
  "uploadFailed": "Le téléversement de la miniature a échoué. Veuillez réessayer."
}
